import {
  getPageInfoInitActions,
  getCommonSectionInitActions,
  getCustomInitActionsForWidgets,
} from './common';

import {
  setSelectedNoteId,
  setSelectedFolder,
} from '../../actions/backroomSection';
import { GroupNotesFolderType } from '../../../types/backroomSection';
import getBackroomWidgetConfigs from '../../components/Sections/BackroomSection/backroomWidgetConfigs';

export function getBackroomSectionInitActions(responseData, requestParams) {
  return [
    ...getPageInfoInitActions(responseData, requestParams),
    setSelectedNoteId(requestParams.noteid),
    setSelectedFolder(GroupNotesFolderType.INBOX),
    ...getCommonSectionInitActions(responseData, requestParams, 'backroom'),
  ].filter(action => action);
}

export const getCustomInitActionsForBackroomWidgets = (
  responseData,
  requestParams
) => [
  ...getCustomInitActionsForWidgets(
    responseData,
    requestParams,
    getBackroomWidgetConfigs({ t: () => null, dispatch: () => null })
  ),
  ...getPageInfoInitActions(responseData, requestParams),
];
